import React, { useState } from 'react';

// import SvgYoutubeMinimalAfter from '../../Icon/YoutubeMinimalAfter';
import SvgYoutubeMinimalBefore from '../../Icon/YoutubeMinimalBefore';

interface LiveMinimalBeforeProps {
  isShowTopBanner?: boolean;
  onClose?: () => void;
  liveStreamHour: string;
  liveStreamMinute: string;
  liveStreamVideoUrl?: string;
  onClickLiveStream: () => void;
}

export default function LiveMinimalBefore({
  isShowTopBanner = false,
  onClose,
  liveStreamHour,
  liveStreamMinute,
  liveStreamVideoUrl = '',
  onClickLiveStream,
}: LiveMinimalBeforeProps) {
  const [isHidden, setIsHidden] = useState(false);
  const topPosition = isShowTopBanner ? 'top-[100px]' : 'top-[60px]';

  const handleClose = () => {
    setIsHidden(true);
    if (onClose) {
      onClose();
    }
  };
  const handleClickWatch = () => {
    window.open(`${liveStreamVideoUrl}`, '_blank');
  };

  if (isHidden) {
    return null;
  }

  return (
    <div
      className={`bg-white border border-gray-200 rounded-[16px] shadow-lg h-[76px] overflow-hidden fixed ${topPosition} z-[100] mx-auto max-w-[720px] w-[97%] left-[50%] translate-x-[-50%] `}
    >
      <div className="flex items-center h-full px-4 gap-3">
        {/* Minimalist icon */}
        <div className="relative">
          <div className="flex items-center justify-center rounded-lg size-[40px] bg-gray-100">
            <SvgYoutubeMinimalBefore />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-0.5">
            <span className="text-[#414141] font-semibold text-[16px]">
              오늘 {liveStreamHour}시 {liveStreamMinute}분 방송 예정
            </span>
          </div>
          <p className="text-[#737373] font-medium text-[14px]">직트럭 라이브를 시청하세요</p>
        </div>

        {/* Clean CTA Button */}
        <button
          className="px-5 py-2 rounded-lg bg-gray-100 text-gray-700 text-[12px] font-semibold whitespace-nowrap"
          onClick={onClickLiveStream}
        >
          시청하기
        </button>
      </div>
    </div>
  );
}
